import React, { useContext, useEffect, useState } from "react";

import { Tabs, Tab, Box } from "@material-ui/core";


import OverWrite from "views/Dashboard/PointsAdjustment/PointsAdjustment";
import ImportData from "views/Dashboard/ImportData/ImportData";
import PointsTransfer from "views/Dashboard/PointsTransfer/PointsTransfer";



export default function PointsManagementScreen() {
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  // Optional: Store components in an array to easily switch
  const components = [
<OverWrite/>,
<ImportData/>,
<PointsTransfer/>


];

 


  return (
    <Box>
  
      <Tabs value={value} onChange={handleChange} aria-label="Points Management Tabs"
      TabIndicatorProps={{
    style: { backgroundColor: '#007bff' }, // e.g., '#1976d2' for blue
  }}>
        <Tab label="Points Adjustment" />
        <Tab label="Import Data" />
        <Tab label="Points Transfer" />

      </Tabs>
   

      <Box sx={{ p: 2 }}>
      {components[value]}
    </Box>
    </Box>
  );
}
